module.exports = "/_next/static/images/Benjimen_Skiba-a30f63d9fc3837b7891a449a78830eb8.webp";